"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _constant = require("./constant");
var _loyaltyTier = _interopRequireDefault(require("./loyalty.tier.proptypes"));
/* eslint-disable react/destructuring-assignment */

var LoyaltyTier = function LoyaltyTier(props) {
  var loyaltyTier = props.loyaltyTier,
    width = props.width,
    height = props.height,
    accessible = props.accessible,
    customProperties = props.customProperties;
  var tabIndex = !accessible ? '-1' : '0';
  var isShowMemberId = loyaltyTier && _constant.MEMBER_TYPES.includes(loyaltyTier);
  var MemberIconSVG = _constant.MEMBER_ICONS[loyaltyTier];
  return isShowMemberId && /*#__PURE__*/_react.default.createElement(MemberIconSVG, (0, _extends2.default)({
    id: "airasia-loyalty-tier",
    tabIndex: tabIndex,
    width: width,
    height: height
  }, customProperties));
};
LoyaltyTier.propTypes = _loyaltyTier.default.PropTypes;
LoyaltyTier.defaultProps = _loyaltyTier.default.DefaultProps;
var _default = LoyaltyTier;
exports.default = _default;